// extracted by mini-css-extract-plugin
export default {"editBtn":"EditGraduate_editBtn__Jq-GT"};